<template lang="">
  <base-link
    v-element-hover="onHover"
    :to="to"
    :external="external"
    class="link-underline link-underline-opacity-0 d-flex justify-content-center align-items-center"
    :class="[
      isHovered ? 'bg-gray-700' : 'bg-body-secondary',
      btnAddFromSearch ? 'btn-add-in-search' : 'h-100 w-100',
    ]"
  >
    <component
      :is="dynamicComponent"
      v-show="dynamicComponent"
      :height="25"
      :width="25"
      :class="[isHovered ? 'text-white' : 'text-dark-emphasis']"
    />
  </base-link>
</template>
<script lang="ts">
import { defineAsyncComponent } from "vue";
import { vElementHover } from "@vueuse/components";
import BaseLink from "~/components/buttons/BaseLink.vue";
export default {
  components: {
    BaseLink,
  },
  directives: {
    "element-hover": vElementHover,
  },
  props: {
    to: {
      type: String,
      default: "/",
    },
    componentSvg: {
      type: String,
      default: null,
      required: true,
    },
    external: {
      type: Boolean,
      default: false,
    },
    btnAddFromSearch: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      isHovered: false,
    };
  },
  computed: {
    dynamicComponent() {
      if (!this.componentSvg) return null;
      return defineAsyncComponent(
        () => import(`~/components/icons/${this.componentSvg}.vue`),
      );
    },
  },
  methods: {
    onHover(state: boolean) {
      this.isHovered = state;
    },
  },
};
</script>
<style lang="sass"></style>
